import React from "react";
import { PlainModal, StandardModalHeader } from "@design-system/Modal/Modal";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { HOTKEYS_SCOPES } from "@hooks/keyboard/useKeyboardCommand";
import { useScopeSwitch } from "@hooks/keyboard/useScopeSwitch";

interface Props {
    show: boolean;
    onCancel: () => void;
    onApply: () => void;
}

// Mounted only while the modal shows: swaps the active hotkey scope to
// GENERAL_MODAL so the command bar's own mod+enter behind the modal goes
// quiet while the Apply hotkey is live.
const ModalHotkeysScope: React.FC = () => {
    useScopeSwitch(HOTKEYS_SCOPES.GENERAL_MODAL);
    return null;
};

export const ConfirmApplyTemplateModal: React.FC<Props> = ({
    show,
    onCancel,
    onApply,
}) => (
    <PlainModal show={show} onHide={onCancel} size="md" hideCloseButton>
        {show && <ModalHotkeysScope />}
        <StandardModalHeader>Replace invoice details?</StandardModalHeader>
        <VStack gap={16} className="mb-4">
            <div>
                Applying this template will overwrite your current unsaved
                changes.
            </div>
        </VStack>
        <HStack as="footer" gap={12} justify="end">
            <Button
                type="button"
                variant="secondary"
                size="md"
                onClick={onCancel}
            >
                Cancel
            </Button>
            <WithHotkey
                hotKey="mod+enter"
                hotKeyDisplayPosition="inline"
                hotKeyOptions={{
                    description: "Apply template",
                    scopes: [HOTKEYS_SCOPES.GENERAL_MODAL],
                }}
            >
                {(hotkeyHint) => (
                    <Button
                        type="button"
                        variant="primary"
                        size="md"
                        onClick={onApply}
                        rightIcon={hotkeyHint}
                    >
                        Apply template
                    </Button>
                )}
            </WithHotkey>
        </HStack>
    </PlainModal>
);
